import * as Redux from 'redux';
import { AppState } from './appState';
import createSagaMiddleware, { SagaMiddleware } from 'redux-saga';
import { appActionReduxifierMiddleware } from './appActionReduxifierMiddleware';
import root from 'acscp/sagas';

export function buildEnhancer(
    composer: (...args: Redux.StoreEnhancer[]) => Redux.StoreEnhancer,
    ...additionalEnhancers: Redux.StoreEnhancer[]
): (sagaMiddleware: SagaMiddleware<{}>) => Redux.StoreEnhancer {

    return (sagaMiddleware: SagaMiddleware<{}>) =>
        composer(
            Redux.applyMiddleware(appActionReduxifierMiddleware, sagaMiddleware),
            ...additionalEnhancers
        );
}

export function configureStore(
        reducer: Redux.Reducer<AppState>,
        enhancerBuilder: (sagaMiddleware: SagaMiddleware<{}>) => Redux.StoreEnhancer)
    : Redux.Store<AppState> {
    const sagaMiddleware = createSagaMiddleware();

    const store = Redux.createStore(reducer, enhancerBuilder(sagaMiddleware));

    sagaMiddleware.run(root);

    return store;
}
